<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <v-data-table id="tsadmin-config-table" :headers="headers" :items="configItems" :search="search" item-key="unique_key" sort-by="key" group-by="section" :items-per-page="-1" class="elevation-1" @dblclick:row="(e, item) => editItemClick(item.item)">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title style="color: #FFD700; font-weight: bold;">TS INI Config</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field color="#c42111" class="" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn @click="newItemClick" color="#c42111" dark class="mb-2">New Item</v-btn>

                    <v-btn-toggle class="ml-3 mb-2" color="#c42111">
                        <v-btn width="" height="36" class="" color="#c42111" @click="getLog('telsaserver')">View Logs</v-btn>
                            <v-menu rounded min-width="180" max-width="180" nudge-left="130" nudge-bottom="40">
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn class="report-action-button right mt-0" color="#c42111" height="36" min-width="48" max-width="48" @click="" v-on="on"><v-icon>mdi-chevron-down</v-icon></v-btn>
                                </template>
                                <v-list color="#303030" style="padding: 0px;">
                                    <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="getLog('alarmsrv')">
                                        <div class="report-action-button-option">
                                            <span class="option-title">Alarmsrv</span>
                                        </div>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="getLog('paged')">
                                        <div class="report-action-button-option">
                                            <span class="option-title">Paged</span>
                                        </div>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="getLog('shakeoutd')">
                                        <div class="report-action-button-option">
                                            <span class="option-title">Shakeoutd</span>
                                        </div>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="getLog('telsaserver')">
                                        <div class="report-action-button-option">
                                            <span class="option-title">TelsaServer</span>
                                        </div>
                                    </v-list-item>
                                    <v-divider />
                                    <v-list-item class="report-action-button-list-item" style="padding-top: 8px; padding-bottom: 8px;" @click="getLog('updsrv')">
                                        <div class="report-action-button-option">
                                            <span class="option-title">Updsrv</span>
                                        </div>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                    </v-btn-toggle>

                </v-toolbar>
            </template>

            <template v-slot:group.header="{ group, headers, toggle, isOpen }">
                <td :colspan="headers.length">
                    <v-btn @click="toggle" small icon :ref="group">
                        <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                    {{ group }}
                </td>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" @click="editItemClick(item)">mdi-pencil</v-icon>
                <v-icon @click="deleteItemClick(item)">mdi-delete</v-icon>
            </template>

            <template v-slot:item.history="{ item }">
                <v-icon @click="showItemHistory(item)">mdi-history</v-icon>
            </template>

            <template v-slot:footer>
                <v-btn @click="saveConfigClick" id="save-button" color="#FFD700" :disabled="lockSave">Save Config</v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="showEditItem" max-width="80%" width="550px" persistent @keydown="(k) => {k.key == 'Escape' ? this.cancelItemClick() : null}">
            <v-card v-if="showEditItem">
                <v-card-title>{{ `${selectedItem.new ? 'New' : 'Edit'} Item` }}</v-card-title>
                <v-divider />
                <v-card-text>
                    <v-form ref="itemForm" :lazy-validation="true" v-model="formValid">
                    <v-row dense>
                        <v-col cols="6">
                            <v-combobox color="#c42111" v-model="selectedItem.section" :items="sections" label="section" :rules="[validation.required(selectedItem.section)]" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field color="#c42111" v-model="selectedItem.key" label="key" :rules="[validation.required(selectedItem.key), validation.uniqueKey(configItems, selectedItem.section, selectedItem.key, originalItem)]" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field color="#c42111" v-model="selectedItem.value" label="value" :rules="[validation.required(selectedItem.value)]" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field color="#c42111" v-model="selectedItem.comment" label="comment" />
                        </v-col>
                    </v-row>
                    </v-form>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="cancelItemClick" text>Cancel</v-btn>
                    <v-btn @click="okItemClick" text>Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showHistory" max-width="80%" width="900px" persistent @keydown="(k) => {k.key == 'Escape' ? this.closeItemHistory() : null}">
            <v-card v-if="showHistory">
                <v-card-title>
                    {{ `History for ${historyItem.section} > ${historyItem.key}` }}
                </v-card-title>
                <v-card-text>
                    <v-simple-table fixed-header height="300">
                        <template v-slot:default>
                            <thead><tr>
                                <th class="text-left">Changed At</th>
                                <th class="text-left">Changed By</th>
                                <th class="text-left">Comment</th>
                                <th class="text-left">Message</th>
                                <th class="text-left">Value</th>
                            </tr></thead>

                            <tbody>
                                <tr v-for="item, idx in historyItem.history" :key="idx">
                                    <td>{{ $store.state.formatDate(item.changed_at, 'YYYY-MM-DD HH:mm:ss') }}</td>
                                    <td>{{ item.changed_by }}</td>
                                    <td>{{ item.comment }}</td>
                                    <td>{{ item.message }}</td>
                                    <td>{{ item.value }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="closeItemHistory" text>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showConfirm" max-width="80%" width="500px" persistent>
            <v-card v-if="showConfirm">
                <v-card-title class="headline" style="color: #FB8C00;">
                    <v-icon class="mr-3" color="#FB8C00">mdi-alert</v-icon> Are you sure?
                </v-card-title>

                <v-card-text>
                    <span v-html="`Make sure you know what you are doing!! Are you sure you want to save your changes? <br><br> Items Added: <b>${this.addCount}</b> <br> Items Edited: <b>${this.editCount}</b> <br> Items Deleted: <b>${this.deleteCount}</b>`" />
                    <v-form ref="commitMessageForm" :lazy-validation="true" v-model="commitMessageFormValid">
                        <v-textarea class="mt-5" v-model="commitMessage" outlined color="#c42111" placeholder="Enter reason for these changes" :rules="[validation.required(commitMessage)]" />
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="#ffffff" text @click="showConfirm = false">Cancel</v-btn>
                    <v-btn color="#ffffff" text @click="saveConfig">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showLogs" max-width="80%" width="80%" persistent>
            <v-card v-if="showLogs">
                <v-card-title>{{this.selectedLog}}</v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <pre class="log-text"> {{logsText}} </pre>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn color="#ffffff" text @click="getLog(selectedLog, 200)">200</v-btn>
                    <v-btn color="#ffffff" text @click="getLog(selectedLog, 500)">500</v-btn>
                    <v-btn color="#ffffff" text @click="getLog(selectedLog, 1000)">1000</v-btn>
                    <v-btn color="#ffffff" text @click="getLog(selectedLog, 3000)">3000</v-btn>
                    <div class="flex-grow-1"></div>
                    <v-btn color="#ffffff" text @click="getLog(selectedLog, lines)">Refresh</v-btn>
                    <v-btn color="#ffffff" text @click="showLogs = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
export default {
    name: 'TelsasoftAdmin',
    props: [],
    components: {

    },
    data: () => ({
        formValid: true,
        lockSave: false,
        configItems: [],
        search: '',
        headers: [
            {text: 'Section', align: 'start', filterable: true, groupable: true, value: 'section'},
            {text: 'Key', filterable: true, groupable: false, value: 'key'},
            {text: 'Value', filterable: true, groupable: false, value: 'value'},
            {text: 'Comment', filterable: true, groupable: false, value: 'comment'},
            {text: 'Actions', filterable: false, groupable: false, value: 'actions'},
            {text: 'History', filterable: false, groupable: false, value: 'history'},
        ],

        showEditItem: false,
        selectedItem: null,
        originalItem: null,
        showHistory: false,
        historyItem: null,
        validation: {
            required: (value) => ((value || value === 0) ? true : false) || `Required`,
            uniqueKey: (items, section, key, original) => (!items.some(i => {return i.section.toLowerCase() == section.toLowerCase() && i.key.toLowerCase() == key.toLowerCase()}) || (original && (original.section == section && original.key == key)) || `Key already exists for this section`)
        },
        addCount: 0,
        editCount: 0,
        deleteCount: 0,
        showConfirm: false,
        commitMessage: '',
        commitMessageFormValid: true,

        showLogs: false,
        selectedLog: null,
        lines: 200,
        logsText: null
    }),

    computed: {
        sections() {
            let sectionsObj = _.groupBy(this.configItems, c => {
                return c.section;
            });
            return Object.keys(sectionsObj);
        }
    },

    methods: {
        getConfig: function() {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "auth/tsiniconfig");
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result);
                this.configItems = result;
                TELSA.loading(false);
                // Collapse all the sections
                this.$nextTick(function() {
                    this.toggleAllGroups();
                });
            });
        },

        newItemClick: function() {
            this.selectedItem = {
                section: '',
                key: '',
                value: '',
                comment: '',
                new: true
            };
            this.showEditItem = true;
        },

        toggleAllGroups: function() {
            Object.keys(this.$refs).forEach(k => {
                this.$refs[k].$el.click();
            });
        },

        editItemClick: function(item) {
            this.originalItem = item;
            this.selectedItem = JSON.parse(JSON.stringify(item));
            this.showEditItem = true;
        },

        cancelItemClick: function() {
            this.showEditItem = false;
            this.selectedItem = null;
        },

        okItemClick: function() {
            if(this.$refs.itemForm.validate()) {
                if(this.selectedItem.new) {
                    // Add new item
                    this.configItems.push(this.selectedItem);
                    this.addCount++;
                    this.selectedItem.new = false;
                }
                else {
                    // Apply edit
                    for(let item of this.configItems) {
                        if(item.section == this.originalItem.section && item.key == this.originalItem.key) {
                            console.log('modify: ', item);
                            item.section = this.selectedItem.section;
                            item.key = this.selectedItem.key;
                            item.value = this.selectedItem.value;
                            item.comment = this.selectedItem.comment;
                            this.editCount++;
                            break;
                        }
                    }
                    this.selectedItem = null;
                    this.originalItem = null;
                }
                this.showEditItem = false;
                this.$store.commit('setIsDirty', true);
            }
        },

        deleteItemClick: function(item) {
            this.configItems.splice(this.configItems.indexOf(item), 1);
            this.deleteCount++;
        },

        saveConfigClick: function() {
            // this.$store.commit('showConfirmModal', {
            //     title: 'Are you sure?',
            //     message: `Make sure you know what you are doing!! Are you sure you want to save your changes? <br><br> Items Added: <b>${this.addCount}</b> <br> Items Edited: <b>${this.editCount}</b> <br> Items Deleted: <b>${this.deleteCount}</b>`,
            //     type: 'warning',
            //     confirmAction: () => {this.saveConfig();}
            // });
            this.commitMessage = '';
            this.showConfirm = true;
        },

        saveConfig: function() {
            if(this.$refs.commitMessageForm.validate()) {
                TELSA.loading(true);
                let route = (TELSA.apiHost + "auth/tsiniconfig");
                return this.$http.post(route, {args: {configItems: this.configItems, commitMessage: this.commitMessage}}).then(response => {
                    let result = response.body;
                    console.log(result);
                    TELSA.loading(false);
                    this.showConfirm = false;
                    this.addCount = 0;
                    this.editCount = 0;
                    this.deleteCount = 0;
                    this.$store.commit('setIsDirty', false);
                });
            }
        },

        getLog: function(logType, lines) {
            let route = (TELSA.apiHost + "support/logs");
            TELSA.loading(true);
            this.selectedLog = logType || this.selectedLog;
            this.lines = lines || this.lines;
            return this.$http.post(route, {args: {type: this.selectedLog, lines: this.lines}}).then(response => {
                let result = response.body;
                this.logsText = result;
                this.showLogs = true;
                TELSA.loading(false);
            });
        },

        refreshLogs: function() {
            this.getLog();
        },

        showItemHistory: function(item) {
            this.historyItem = item;
            this.showHistory = true;
        },

        closeItemHistory: function() {
            this.showHistory = false;
            this.historyItem = null;
        }
    },

    mounted() {
        let lockName = `edit_tsini`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getConfig().then(r => {
                if(lockOwner) {
                    // Disable save and let user know page is locked
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The tsini config is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
            });
        });
    }
  
};
</script>

<style scoped>

    #save-button {
        position: absolute;
        margin-top: 12px;
        margin-left: calc(50% - (135px / 2));
        color: #000;
    }

    .log-text {
        overflow-x: auto;
        overflow-y: auto;
    }

</style>

<style>

    #tsadmin-config-table .v-data-table__wrapper {
        max-height: calc(100vh - 220px);
        overflow-y: auto;
    }

</style>
